import { MetricSelect } from 'components/Input/SortSelect';
import { useState } from 'react';

const createSelectOptionFromMetric = (metric) => {
    const sortOption = metric.getSortOption({ ascending: false });
    return {
        label: metric.tableHeadColumnLabel,
        value: metric.tableHeadColumnLabel,
        tooltip: sortOption.tooltip,
        mixpanelContentKey: metric.mixpanelContentKey,
        format: metric.format,
        key: metric.key,
        dataSource: sortOption.dataSource,
    };
};

const useMetricSelect = ({
    metricsList,
    metrics,
    defaultMetric,
    tikTokSourceAttributionProps,
}) => {
    const [selected, setSelected] = useState(
        createSelectOptionFromMetric(defaultMetric || metricsList[0]),
    );
    const formattedValue = selected.format(metrics?.[selected.key]);
    const selectMenu = (
        <MetricSelect
            options={metricsList.map(createSelectOptionFromMetric)}
            value={selected}
            onChange={(selected) => setSelected(selected)}
            mixpanelContext="MetricSortSelect"
            css="min-width: 3.5rem;"
            {...tikTokSourceAttributionProps}
        />
    );
    return { selected, formattedValue, selectMenu };
};

export default useMetricSelect;
